<script setup lang="ts">
import { Form, Head } from '@inertiajs/vue3';
import TextLink from '@/components/TextLink.vue';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { logout } from '@/routes';
import { send } from '@/routes/verification';

defineOptions({
    layout: {
        title: 'Verifiez votre email',
        description:
            'Confirmez votre adresse email en cliquant sur le lien que nous venons de vous envoyer.',
    },
});

defineProps<{
    status?: string;
}>();
</script>

<template>
    <Head title="Verification email" />

    <div
        v-if="status === 'verification-link-sent'"
        class="mb-6 rounded-2xl border border-brand/20 bg-brand/[0.08] px-4 py-3 text-sm font-medium text-brand"
    >
        Un nouveau lien de verification vient d'etre envoye a l'adresse email
        utilisee lors de l'inscription.
    </div>

    <div
        class="mb-6 rounded-2xl border border-border/70 bg-muted/30 px-4 py-4 text-sm leading-6 text-muted-foreground"
    >
        Ouvrez le message que nous vous avons envoye, confirmez votre adresse,
        puis revenez ici. Si rien n'arrive dans la minute, verifiez votre
        dossier spam avant de demander un nouveau lien.
    </div>

    <Form
        v-bind="send.form()"
        class="flex flex-col gap-4 text-center"
        v-slot="{ processing }"
    >
        <Button
            :disabled="processing"
            variant="brand"
            size="lg"
            class="w-full rounded-full"
        >
            <Spinner v-if="processing" />
            Renvoyer l'email de verification
        </Button>

        <p class="text-sm text-muted-foreground">
            Vous devez utiliser un autre compte ?
        </p>

        <TextLink
            :href="logout()"
            as="button"
            class="mx-auto block text-sm text-brand decoration-brand/30 hover:decoration-brand"
        >
            Se deconnecter
        </TextLink>
    </Form>
</template>
